import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import CustomModal from '../../customModal';
import InputField from '../../inputField';
import PresetSummary from './presetSummary';

const useStyles = makeStyles(({ spacing }) => ({
  input: {
    marginBottom: spacing(6),
  },
  inputError: {
    marginBottom: spacing(1),
  },
  summary: {
    marginTop: spacing(2),
  },
  summaryDescription: {
    marginBottom: spacing(2),
  },
}));

const SavePresetDialog = ({
  translations,
  isOpened,
  presetName,
  hasError,
  errorMessage,
  isConfirmDisabled = false,
  presetSummary = null,
  onClose,
  onConfirm,
  onPresetNameChange,
}) => {
  const classes = useStyles();

  return (
    <CustomModal
      title={translations.savePresetTitle}
      confirmButtonLabel={translations.save}
      closeButtonLabel={translations.cancel}
      isOpened={isOpened}
      isConfirmDisabled={isConfirmDisabled}
      onClose={onClose}
      onConfirm={onConfirm}
      isMedium
    >
      <div
        className={classNames(classes.input, {
          [classes.inputError]: hasError,
        })}
      >
        <InputField
          name="presetName"
          label={translations.placeholder}
          placeholder={translations.inputPlaceholder}
          value={presetName}
          error={hasError}
          errorMessage={errorMessage}
          onChange={onPresetNameChange}
          fullWidth
        />
      </div>
      {presetSummary && (
        <div className={classes.summary}>
          <Typography className={classes.summaryDescription} variant="body2">
            {translations.selectedValuesDescription}
          </Typography>
          <PresetSummary
            {...presetSummary}
            nothingSelected={translations.nothingSelected}
          />
        </div>
      )}
    </CustomModal>
  );
};

SavePresetDialog.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  presetName: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  isConfirmDisabled: PropTypes.bool,
  presetSummary: PropTypes.shape({
    translations: PropTypes.shape({
      surveyType: PropTypes.string,
      range: PropTypes.string,
      attribute: PropTypes.string,
      attributes: PropTypes.string,
      scores: PropTypes.string,
      people: PropTypes.string,
      subject: PropTypes.string,
      reviewers: PropTypes.string,
    }).isRequired,
    hasSurveyType: PropTypes.bool,
    hasRange: PropTypes.bool,
    hasAttributes: PropTypes.bool,
    hasSingleAttribute: PropTypes.bool,
    hasScores: PropTypes.bool,
    hasUserList: PropTypes.bool,
    hasSubjectList: PropTypes.bool,
    hasReviewerList: PropTypes.bool,
    hasCompareFilters: PropTypes.bool,
    hasFilterSections: PropTypes.bool,
    filterSections: PropTypes.arrayOf(PropTypes.object),
    surveyTypeLabel: PropTypes.string,
    range: PropTypes.shape({
      startDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      endDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
    }),
    attributes: PropTypes.arrayOf(PropTypes.object),
    attribute: PropTypes.object,
    scores: PropTypes.arrayOf(PropTypes.number),
    users: PropTypes.arrayOf(PropTypes.object),
    subjectUsers: PropTypes.arrayOf(PropTypes.object),
    reviewerUsers: PropTypes.arrayOf(PropTypes.object),
    compareFilters: PropTypes.arrayOf(PropTypes.object),
    checkIsSelectable: PropTypes.func,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onPresetNameChange: PropTypes.func.isRequired,
};

export default SavePresetDialog;
